import { render, staticRenderFns } from "./person-detail.vue?vue&type=template&id=22b35227&scoped=true"
import script from "./person-detail.vue?vue&type=script&lang=ts"
export * from "./person-detail.vue?vue&type=script&lang=ts"
import style0 from "./person-detail.vue?vue&type=style&index=0&id=22b35227&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b35227",
  null
  
)

export default component.exports